import {
    StepPersonalData,
    StepPlans,
    StepPersonalData2,
    StepDataContent,
    StepFinish,
    StepPurchaseSummary,
    StepAutomaticPayment,
    StepPaymentCompleted
} from '../step'

const txtNext = 'Siguiente';
const txtBack = 'Regresar';

const siteTitleMain: Array<string> = [
    '¡Calcula tu seguro ahora!',
    '¡Calcula tu seguro ahora!',
    '¡Calcula tu seguro ahora!',
    '¡Calcula tu seguro ahora!',
    'Compre su Seguro en línea aquí',
    '',
    '',
    ''
]

const lstPage: Array<IPageInfo> = [
    {
        indexBar: 1,
        title1: 'Datos personales',
        title2: '(*) Espacios requeridos',
        title3: '¡Queremos conocerte! Ingresá los siguientes datos, según tu documento de identidad',
        txtBtnNext: txtNext,
        page: <StepPersonalData />
    } as IPageInfo,
    {
        indexBar: 2,
        title1: 'Planes, coberturas y suma asegurada',
        title2: '(*) Espacios requeridos',
        title3: 'Ingresá los siguientes datos de tu contenido que deseas asegurar',
        txtBtnNext: txtNext,
        txtBtnBack: txtBack,
        page: <StepPlans />
    } as IPageInfo,
    {
        indexBar: 3,
        title1: 'Datos de tu contenido',
        title2: '(*) Espacios requeridos',
        title3: 'Ingresá los siguientes datos de tu contenido que deseas asegurar',
        txtBtnNext: txtNext,
        txtBtnBack: txtBack,
        page: <StepDataContent />
    } as IPageInfo,
    {
        indexBar: 4,
        title1: 'Datos personales',
        title2: '(*) Espacios requeridos',
        title3: 'Ingresá los siguientes datos de tu contenido que deseas asegurar',
        txtBtnNext: txtNext,
        txtBtnBack: txtBack,
        page: <StepPersonalData2 />
    } as IPageInfo,
    {
        indexBar: 5,
        title1: 'Resumen de compra',
        title2: '(*) Espacios requeridos',
        title3: 'A continuación le presentamos un resumen de la compra de su póliza de Contenido Seguro',        
        page: <StepPurchaseSummary />
    } as IPageInfo,
    {
        indexBar: 5,
        title1: 'Pago de la póliza',
        title2: '(*) Espacios requeridos',
        title3: '¿Acepta la tarjeta que utilizó sea guardada para el pago de las cuotas siguientes?',    
        page: <StepAutomaticPayment />,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        indexBar: 0,
        title1: '',
        title2: '',
        title3: '',
        page: <StepPaymentCompleted />
    } as IPageInfo,
    {
        indexBar: 4,
        title1: '',
        title2: '',
        title3: '',
        page: <StepFinish />
    } as IPageInfo,
]

const catTypeDocument: Array<ICatalog> = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

const catPlan = [
    { value: '595', text: 'Dólares' },
    { value: '594', text: 'Colones' },
]

const catSumInsuredColones = [
    { value: '5000000', text: '₡ 5,000,000' },
    { value: '10000000', text: '₡ 10,000,000' },
    { value: '15000000', text: '₡ 15,000,000' },
    { value: '20000000', text: '₡ 20,000,000' }
]

const catSumInsuredDolar = [
    { value: '7300', text: 'U$ 7,300' },
    { value: '14650', text: 'U$ 14,650' },
    { value: '22000', text: 'U$ 22,000' },
    { value: '29300', text: 'U$ 29,300' },
]

const catCoveragesName = [
    { value: '534', text: 'Daño directo a los bienes de contenido' },
    { value: '535', text: 'Riesgos de Naturaleza Catastrofica' },
    { value: '536', text: 'Asistencia' },
]

const catGender: Array<ICatalog> = [
    { value: 'F', text: 'Femenino' } as ICatalog,
    { value: 'M', text: 'Masculino' } as ICatalog,
]

const catSiNo: Array<ICatalog> = [
    { value: 'S', text: 'Si' } as ICatalog,
    { value: 'N', text: 'No' } as ICatalog
]
const catCardType: Array<ICatalog> = [
    { value: 'TR', text: 'Débito' } as ICatalog,
    { value: 'TZ', text: 'Crédito' } as ICatalog
]


const enum stepEnum {
    StepPersonalData,
    StepPlans,
    StepDataContent,
    StepPersonalData2,
    StepPurchaseSummary,
    StepAutomaticPayment,
    StepPaymentCompleted,
    StepFinish,
}

export {
    lstPage,
    siteTitleMain,
    catTypeDocument,
    catPlan,
    catSumInsuredColones,
    catSumInsuredDolar,
    catCoveragesName,
    stepEnum,
    catGender,
    catSiNo,
    catCardType
}